import { render, staticRenderFns } from "./OrbitLeaderboardScrollableTable.vue?vue&type=template&id=2cdd76d2&scoped=true"
import script from "./OrbitLeaderboardScrollableTable.vue?vue&type=script&lang=ts"
export * from "./OrbitLeaderboardScrollableTable.vue?vue&type=script&lang=ts"
import style0 from "./OrbitLeaderboardScrollableTable.vue?vue&type=style&index=0&id=2cdd76d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdd76d2",
  null
  
)

export default component.exports